export class ListUpdateStatusViewModel {
    empId: number;
    printCodeId: number;
    receiveHubId: number;
    shipmentStatusId: number;
    currentLat: number; 
    currentLng: number; 
    location: string;
    note: string;
    shipmentIds: number[];
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/listUpdateStatus.viewModel.ts